import React from "react";
import Tooltip from "@adsk/alloy-react-tooltip";
import { AlertInformationIcon } from "@adsk/alloy-react-icon";
import Theme from "@adsk/alloy-react-theme";
import { useTranslations } from "@adsk/acc-issues-translations";
import A from "@adsk/alloy-react-a";

export const StatusFieldLabel = () => {
  const { T } = useTranslations();
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {T.translate("issueAttributes.status")}
      <Tooltip
        triggerTarget={Tooltip.TRIGGER_TARGETS.TOOLTIP}
        style={{ width: 300 }}
        placement={Tooltip.PLACEMENTS.TOP}
        variant={Tooltip.VARIANTS.DARK}
        content={<StatusFieldTooltipContent />}
      >
        <AlertInformationIcon
          size={16}
          style={{
            marginTop: 5,
            marginLeft: 5,
            color: Theme.colors.adskBlue700,
          }}
        />
      </Tooltip>
    </div>
  );
};

const StatusFieldTooltipContent = () => {
  const { T } = useTranslations();
  return (
    <div>
      <span>{T.translate("issueEditForm.status.tooltip")}</span>
      <hr
        style={{
          height: "1px",
          border: "none",
          backgroundColor: Theme.colors.charcoal700,
          color: Theme.colors.charcoal700,
        }}
      />
      <A
        href={T.translate("issueEditForm.status.helpArticleUrl") as string}
        target="_blank"
        style={{ color: Theme.colors.white, fontWeight: "bold" }}
      >
        {T.translate("actions.learnMore") as string}
      </A>
    </div>
  );
};
